/* Dravella — garde-fou des lots « une ligne par article » (17/10/2026).
   Un lot (2, 3, 4 articles) arrive en N lignes au prix d'UN article du lot. Si la cliente retire une ligne
   ou change une quantité, le reste du lot ne vaut plus le prix du lot : les unités en trop repassent
   sur la variante normale (prix plein). Rien d'autre n'est touché. */
(() => {
  const G = [
    { m: [54381472350555], n: 2, s: () => 54381472317787 },                    // SmartDrain lot de 2
    { m: [54381472383323, 54403598254427], n: 3, s: () => 54381472317787 },                    // SmartDrain lot de 3
    { m: [54301349970267], n: 2, s: () => 54301349937499 },                    // Cap Washer lot de 2
    { m: [54301350003035, 54399127257435], n: 3, s: () => 54301349937499 },    // Cap Washer lot de 3
    { m: [54293203550555], n: 4, s: () => 54292631060827 },                    // Poachly 2 + 2
    { m: [54377056141659, 54377056174427, 54377056207195, 54377056239963], n: 3, // Fairy Glow Puff 2 + 1
      s: (v) => ({ 54377056141659: 54269156589915, 54377056174427: 54269156622683,
                   54377056207195: 54269156655451, 54377056239963: 54269156688219 })[v] },
    { m: [54406536757595,  54406536855899,  54406536954203], n: 2, // Auto-Fit Belt lot de 2
      s: (v) => ({ 54406536757595: 54406536724827, 54406536855899: 54406536823131, 54406536954203: 54406536921435 })[v] },
    { m: [54406536790363,  54406536888667,  54406536986971], n: 3, // Auto-Fit Belt lot de 3
      s: (v) => ({ 54406536790363: 54406536724827, 54406536888667: 54406536823131, 54406536986971: 54406536921435 })[v] }
  ];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const F = window.fetch.bind(window);
  let busy = false;

  async function guard() {
    if (busy) return; busy = true;
    try {
      const cart = await F(root + "cart.js").then((r) => r.json());
      let changed = false;
      for (const g of G) {
        const lines = cart.items.filter((i) => g.m.includes(i.variant_id));
        let extra = lines.reduce((a, i) => a + i.quantity, 0) % g.n;
        for (let k = lines.length - 1; k >= 0 && extra > 0; k--) {
          const l = lines[k], take = Math.min(extra, l.quantity);
          await F(root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: l.key, quantity: l.quantity - take }) });
          const items = []; for (let t = 0; t < take; t++) items.push({ id: g.s(l.variant_id), quantity: 1, properties: { _l: "solo" } });
          await F(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items }) });
          extra -= take; changed = true;
        }
      }
      if (changed) {
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        const dr = document.querySelector("cart-drawer");
        if (dr && dr.getSectionsToRender && dr.renderContents) {
          const ids = dr.getSectionsToRender().map((s) => s.id);
          const sections = await F(location.pathname + "?sections=" + ids.join(",")).then((r) => r.json());
          dr.renderContents({ sections });
        }
      }
    } catch (e) {} finally { busy = false; }
  }

  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const p = F(input, init);
    if (!busy && /\/cart\/(change|update)(\.js)?/.test(url)) p.then(() => setTimeout(guard, 150));
    return p;
  };
  if (document.readyState !== "loading") guard(); else document.addEventListener("DOMContentLoaded", guard);
})();
